import { TYPES, container } from '@/libs/di/inversify.config'
import type { ActionTree } from 'vuex'
import type { State } from './state'

import { trackSession, unsetTrackingPlanner } from '@/sentry'

export const actions: ActionTree<State, State> = {
  async login(
    { commit },
    payload: { email: string; password: string }
  ): Promise<void> {
    const token = await container
      .get(TYPES.AccountUsecase)
      .requestLogin(payload)
    commit('updateAPIToken', token)
  },

  async logout({ commit, getters }): Promise<void> {
    if (getters.apiToken == null) {
      return
    }
    await container.get(TYPES.AccountUsecase).postLogout()
    unsetTrackingPlanner()
    commit('clearAPIToken')
  },

  async updateSession(): Promise<void> {
    const { longSessionId } = await container
      .get(TYPES.AccountUsecase)
      .updateSession()
    trackSession(longSessionId)
  },
}
